<div class="mb-3 pt-5 text-center">
    <h6 class="text-base font-normal">{{'CLIENT_BOOKING.NO_BOOKINGS' | translate}}</h6>
    <img src="/assets/img/booking-empty-img.svg" [alt]="'CLIENT_BOOKING.NO_BOOKINGS' | translate" />
</div>